export const hexToHSL = (hex) => {
	// Remove the # character if present
	hex = hex.replace('#', '');

	// Convert hex to RGB
	const r = parseInt(hex.substring(0, 2), 16) / 255;
	const g = parseInt(hex.substring(2, 4), 16) / 255;
	const b = parseInt(hex.substring(4, 6), 16) / 255;

	// Find the maximum and minimum values of R, G, and B
	const max = Math.max(r, g, b);
	const min = Math.min(r, g, b);

	// Calculate the lightness
	let l = (max + min) / 2;

	let h, s;
	// Check if the color is grayscale
	if (max === min) {
		h = 0;
		s = 0;
	} else {
		// Calculate the saturation
		s = l > 0.5 ? (max - min) / (2 - max - min) : (max - min) / (max + min);

		// Calculate the hue
		switch (max) {
			case r:
				h = (g - b) / (max - min) + (g < b ? 6 : 0);
				break;
			case g:
				h = (b - r) / (max - min) + 2;
				break;
			case b:
				h = (r - g) / (max - min) + 4;
				break;
		}
		h /= 6;
	}

	// Convert HSL to percentages
	h *= 360;
	s *= 100;
	l *= 100;

	// Format the HSL values
	const formattedHSL = `${h.toFixed(1)} ${s.toFixed(1)}% ${l.toFixed(1)}%`;
	return formattedHSL;
};